/**
 * Builds Postgres assignment payloads for the reassign modal.
 * @module reAssignModal/utils/buildOrderReassignmentPayload
 */

import { UNASSIGNED_TEXT } from "../../../../constants/stringLiterals";
import { generateFullName } from "../../../../utils/generateOrderDataForTable";
import { OrderReassignmentPayload, ReassignModalProvider } from "../types";

/**
 * Builds the assignment update payload for a selected provider.
 *
 * @param providerId - Selected provider document id or unassigned sentinel
 * @param providersDetails - Full provider list from Redux
 * @returns Assignment fields for single-order or bulk Postgres update
 */
export const buildOrderReassignmentPayload = (
  providerId: string,
  providersDetails: ReassignModalProvider[] | undefined,
): OrderReassignmentPayload => {
  const selectedProvider = providersDetails?.find(
    (provider) => provider.id === providerId,
  );

  return {
    assigned_to_id: providerId,
    assigned_to_name: generateFullName(
      selectedProvider?.FirstName || selectedProvider?.name || UNASSIGNED_TEXT,
      "",
      selectedProvider?.LastName || "",
    ),
  };
};
